module.exports = __webpack_public_path__ + "img/gy10.445bef91.png";